import { render, staticRenderFns } from "./colorSize.vue?vue&type=template&id=3759641a&scoped=true"
import script from "./colorSize.vue?vue&type=script&lang=js"
export * from "./colorSize.vue?vue&type=script&lang=js"
import style0 from "./colorSize.vue?vue&type=style&index=0&id=3759641a&prod&lang=scss&scoped=true"
import style1 from "./colorSize.vue?vue&type=style&index=1&id=3759641a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3759641a",
  null
  
)

export default component.exports